<template>
    <div class="flex flex-col items-center pb-20 bg-black bg-cover bg-center bg-no-repeat"
        style="background-image: url('/images/bg/btmbg.png');">
        <div class="flex flex-col self-stretch pb-14 mt-20 w-full max-md:mt-10 max-md:max-w-full">

            <div class="flex gap-5 self-center px-5 mt-8 font-semibold text-white whitespace-nowrap max-md:flex-wrap">
                <div class="flex-auto my-auto text-5xl">我们倾听您的声音</div>
                <router-link to="/about">
                <div class="px-7 py-2.5 text-3xl rounded-sm border border-violet-300 border-solid max-md:px-5">
                    联系我们
                </div>
                </router-link>
            </div>

            <div>
                <div class="h-px bg-white mx-4 mt-44"></div>
            </div>
            <div class="flex flex-col pr-1.5 pl-6 mt-2 w-full max-md:pl-5 max-md:mt-10 max-md:max-w-full">
                <div class="mt-16 ml-16 max-w-full w-[719px] max-md:mt-10">
                    <div class="flex gap-5 max-md:flex-col">
                        <div class="flex flex-col w-[18%] max-md:ml-0">
                            
                            <div class="flex flex-col grow text-xl text-white whitespace-nowrap max-md:mt-10">
                                <div>快速连接</div>
                                <div class="mt-9"><router-link to="/products">产品介绍</router-link></div>
                                <div class="mt-10 max-md:mt-10">技术支持</div>
                                <div class="mt-10"><router-link to="/about">联系我们</router-link></div>
                            </div>
                        
                        </div>
                        <div class="flex flex-col ml-5 w-[18%] max-md:ml-0 ">
                            <div class="flex flex-col text-xl text-white whitespace-nowrap max-md:mt-10">
                                <div>关于公司</div>
                                <div class="mt-8">加入我们</div>
                                <div class="mt-10"><router-link to="/honor">荣誉信息</router-link></div>
                            </div>
                        </div>
                        <div class="flex flex-col ml-5 w-[63%] max-md:ml-0 ">
                            <div class="flex flex-col text-xl text-white text-left whitespace-normal max-md:mt-10">
                                <div>公司信息</div>
                                <div class="mt-7">深圳市瑜威电子科技有限公司</div>
                                <div class="mt-3.5">地址：深圳市南山区粤海街道高新区社区深南大道9789号德赛科技大厦1904A</div>
                                <div class="mt-3.5">电话：13424453456</div>
                            </div>
                        </div>
                        <div class="flex flex-col ml-5 w-[63%] max-md:ml-0 ">
                            <div class="flex flex-col text-xl text-white text-left whitespace-nowrap max-md:mt-10">
                                <div>备案信息</div>
                                <div class="mt-7" >
                                    <a href="https://beian.miit.gov.cn/" target="_blank">粤ICP备2024299876号</a>
                                </div>
                                <div class="mt-7" >
                                    粤公网安备44030002004676号
                                </div>
                                <div class="mt-3.5"></div>
                            </div>
                        </div>

                    </div>
                </div>
            </div>
        </div>

    </div>
</template>

<script>
export default {
    name: 'BtmBar'
};
</script>